export const model = {
    id: null,
    day: '', 
    comment: '', 
    time: '', 
    created_at: '',
    updated_at: ''
};
